import { lazy } from 'react'

export const PageAtlasPrigorodnoePassazhSoobshchenieAsync = lazy(
  () => import('./page_atlas_prigorodnoe-passazh-soobshchenie')
)
